import React from 'react';
import { Facebook, Instagram, Phone } from 'lucide-react';

const SocialSidebar = () => {
  return (
    <div className="fixed left-0 top-1/2 transform -translate-y-1/2 z-40">
      <div className="flex flex-col space-y-0">
        <a
          href="https://www.facebook.com/profile.php?id=61587563577577"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 hover:bg-blue-700 text-white p-3 transition-colors duration-300"
          aria-label="Facebook"
        >
          <Facebook size={20} />
        </a>
        <a
          href="https://www.instagram.com/jokerandquinnsalon/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-pink-600 hover:bg-pink-700 text-white p-3 transition-colors duration-300"
          aria-label="Instagram"
        >
          <Instagram size={20} />
        </a>
        <a
          href="tel:+919884022956"
          className="bg-green-600 hover:bg-green-700 text-white p-3 transition-colors duration-300"
          aria-label="Phone"
        >
          <Phone size={20} />
        </a>
      </div>
    </div>
  );
};

export default SocialSidebar;
